// generated by genversion
export const version = '0.7.0';
